module.exports = __webpack_public_path__ + "static/media/xueshanadj.18bfbdf5.png";